<template>
    <div id="receipt_invoice_mapper" class="fleet-form-main">
        <div :class="`loader${loaderClass}`" v-show="loading">
        </div>
        <div id="page-content-wrapper" class="admin-content-area">
            <template v-if="cantAccessPage === true">
                <div class="page-name">
                    <span class="page-title" id="ReceiptInvoiceHeader">Maintain Payment Invoice</span>
                    <div class="web-action-btn btn-groups text-right">
                        <button v-if="adjustButton" type="submit" id="createReceiptBtn" class="btn btn-primary" v-on:click.prevent="adjustReceipt">
                            Adjustment
                        </button>
                        <button type="submit" class="btn btn-secondary" v-on:click.prevent="BackReceiptList" >
                            <i class="fp-back"> </i> Back
                        </button>
                    </div>
                </div>
                <div class="container-fluid">
                    <div class="admin-page-content map-receipt-invoice">
                        <section class="internal-container border-top-table-fl">
                            <form autocomplete="off" class="form-horizontal basic-form-container metric-form invoice-mapper" id="ReceiptInvoiceMapperForm">
                                <div class="form-row">
                                    <div class="col-md-7 form-group">
                                        <div class="form-row">
                                            <div class="col form-group">
                                                <label class="control-label" for="receipt">Receipt/Payment Number:</label>
                                                <v-select v-model="receiptPayment" name="receipt"
                                                        label="text" :filterable="false" :options="receiptPaymentArr"
                                                        @search="onSearchReceiptPayment"
                                                        placeholder="Select Receipt" class="custom-ci-auto-search">
                                                    <template slot="no-options">
                                                        Search Receipt/Payment...
                                                    </template>
                                                    <template slot="option" slot-scope="option">
                                                        <div class="d-center">
                                                            {{ option.text }}
                                                        </div>
                                                    </template>
                                                    <template slot="selected-option" slot-scope="option">
                                                        <div class="selected d-center">
                                                            {{ option.text }}
                                                        </div>
                                                    </template>
                                                </v-select>
                                            </div>
                                        </div>
                                        <template v-if="payment_number != ''">
                                            <div class="form-row">
                                                <div class="col form-group">
                                                    <label class="control-label">Search Customer/Invoice#</label>
                                                    <div class="border-1">
                                                        <div class="form-row">
                                                            <div class="col-md-5">
                                                                <label class="control-label" for="customer_id">Customer:</label>
                                                                <v-select v-model="customer_id" name="customer_id" id="customer_id" label="text" :filterable="false" :options="customerArr" @search="onSearchCustomer" placeholder="Select Customer" class='custom-ci-auto-search'>
                                                                    <template slot="no-options">
                                                                        Search Customer...
                                                                    </template>
                                                                    <template slot="option" slot-scope="option">
                                                                        <div class="d-center">
                                                                            {{ option.text }}
                                                                        </div>
                                                                    </template>
                                                                    <template slot="selected-option" slot-scope="option">
                                                                        <div class="selected d-center">
                                                                            {{ option.text }}
                                                                        </div>
                                                                </template>
                                                                </v-select>
                                                                <div class="field-error">{{ customer_error_msg }}</div>
                                                            </div>
                                                            <div class="col-md-5">
                                                                <label class="control-label" for="invoice_id">Invoice Number:</label>
                                                                <v-select v-model="invoice_id" name="invoice_id" multiple id="invoice_id" label="text" :filterable="false" :options="invoiceArr" @search="onSearchInvoice" placeholder="Select Invoice" class='custom-ci-auto-search invoice-multiple'>
                                                                    <template slot="no-options">
                                                                        Search Invoice...
                                                                    </template>
                                                                    <template slot="option" multiple slot-scope="option">
                                                                        <div class="d-center">
                                                                            {{ option.text }}
                                                                        </div>
                                                                    </template>
                                                                    <template slot="selected-option" multiple slot-scope="option">
                                                                        <div class="selected d-center">
                                                                            {{ option.text }}
                                                                        </div>
                                                                    </template>
                                                                </v-select>
                                                                <div class="field-error">{{ invoice_error_msg }}</div>
                                                            </div>
                                                            <div class="col-md-2">
                                                                <button type="submit" v-on:click.prevent="getInvoices()" class="btn btn-primary mt-4">
                                                                    <i class="fp-add"></i> Add
                                                                </button>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="misc-cash mt-5" style="font-size:0.9rem;">
                                                <a href="javascript:void(0)" v-on:click.prevent="creditDeposit()" class="color-blue underline">
                                                    Security Deposit
                                                </a>

                                                <span class="clearfix display-block mt-2"></span>
                                                <a href="javascript:void(0)" v-on:click.prevent="onAccountApp()" class="color-blue underline">
                                                    On Account Fund
                                                </a>
                                                <span class="clearfix display-block mt-2"></span>
                                                <a href="javascript:void(0)" v-on:click.prevent="cashFlow()" class="color-blue underline">
                                                    Direct GL Entry
                                                </a>

                                                <template v-if="creditrows && creditrows.length > 0 && onSecurityDeposit">
                                                  <span class="clearfix display-block mt-2"></span>
                                                  <div class="custom-checkbox">
                                                      <label class="checkbox-custom">With Asset
                                                        <input type="checkbox" v-model="isUnit" id="isUnit"
                                                        name="isUnit" v-on:click="isUnitSelect($event)">
                                                        <span class="checkmark"></span>
                                                      </label>
                                                  </div>
                                                </template>


                                            </div>
                                        </template>
                                    </div>
                                    <div class="col-md-5">
                                        <template v-if="payment_number != ''">
                                            <table aria-describedby="table" class="table table-sm table-bordered font-1">
                                                <tbody>
                                                    <tr class="table-active">
                                                        <td>Payment Number: </td>
                                                        <td>Payment Date: </td>
                                                    </tr>
                                                    <tr>
                                                        <td>{{payment_number}}</td>
                                                        <td>{{payment_date}}</td>
                                                    </tr>
                                                    <tr class="table-active">
                                                        <td>Bank Code:</td>
                                                        <td>Payment Type:</td>
                                                    </tr>
                                                    <tr>
                                                        <td>{{bank_code}}</td>
                                                        <td>{{payment_type}}</td>
                                                    </tr>
                                                    <tr class="table-active">
                                                        <td>Payment CC Code: </td>
                                                        <td>DIST Company:</td>
                                                    </tr>
                                                    <tr class="section">
                                                        <td>{{payment_currency_code}}</td>
                                                        <td><input type="text" class="form-control" v-model="dist_company" id="dist_company" placeholder="Enter Dist Company" name="dist_company"></td>
                                                    </tr>
                                                </tbody>
                                            </table>
                                            <table aria-describedby="table" class="table table-sm table-bordered" style="font-size:14px;">
                                                <tbody>
                                                    <tr>
                                                        <td class="bg-gray require valign-middle"> PMT Amount: </td>
                                                        <td class="text-right"> ${{payment_amount.toFixed(2)}}</td>
                                                    </tr>
                                                    <tr>
                                                        <td class="bg-gray"> Amt Applied: </td>
                                                        <td class="text-right"> ${{amount_applied.toFixed(2)}}</td>
                                                    </tr>
                                                    <tr>
                                                        <td class="bg-gray"> Difference: </td>
                                                        <td class="text-right font-semibold"> ${{difference.toFixed(2)}} </td>
                                                    </tr>
                                                </tbody>
                                            </table>
                                        </template>
                                    </div>
                                </div>
                                <template v-if="payment_number != ''">
                                    <div class="purchase-order-create-main table-responsive-sm" v-if="rows && rows.length > 0">
                                        <div v-if="idArr && idArr.length > 0" class="selection-info-row">
                                            <a href="javascript:void(0)" v-on:click.prevent="cancelReceiptPayment()" class="color-blue underline">Cancel</a>
                                        </div>
                                        <table aria-describedby="table" class="table table-sm table-bordered font-1">
                                            <thead>
                                                <tr class="table-primary">
                                                    <th scope="col" style="width:10px;"></th>
                                                    <th scope="col" style="width:200px;">Customer</th>
                                                    <th scope="col">Invoice Number</th>
                                                    <th scope="col">Original Amount</th>
                                                    <th scope="col">Open Amount</th>
                                                    <th scope="col" style="width:20px;">Status</th>
                                                    <th scope="col" style="width:20px;">Action</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr v-for="(row, index) in rows" :key="index">
                                                    <td>
                                                        <input type="checkbox" id="cancelCheckbox" @input="clickRows($event,row.mapper_id)"/>
                                                    </td>
                                                    <td>
                                                        {{row.customer_number}}
                                                    </td>
                                                    <td>
                                                        {{row.invoice_number}}
                                                    </td>
                                                    <td v-if="row.invoice_amount">
                                                        ${{row.invoice_amount.toFixed(2)}}
                                                    </td>
                                                    <td>
                                                        ${{row.current_open_inv_amount.toFixed(2)}}
                                                    </td>
                                                    <td>
                                                        <span v-if="row.mapper_id > 0">
                                                            Applied
                                                        </span>
                                                        <span v-else>
                                                            Un applied
                                                        </span>
                                                    </td>
                                                    <td>
                                                        <template v-if="rows.length > 0">
                                                            <a href="javascript:void(0)" v-if="row.current_open_inv_amount > 0" v-on:click.prevent="grossInvoice(row.invoice_id,row.current_open_inv_amount)" class="color-blue underline">
                                                                Gross
                                                            </a>
                                                            <a  href="javascript:void(0)" v-if="row.current_open_inv_amount > 0" v-on:click.prevent="spInvoice(row.invoice_id,row.current_open_inv_amount)" class="color-blue underline">
                                                                Specific
                                                            </a>
                                                            <span class="close-row" v-if="row.current_open_inv_amount == 0"> - </span>
                                                        </template>
                                                        <template v-else>
                                                            <span class="close-row"> - </span>
                                                        </template>
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                    <div v-if="accrows && accrows.length > 0 && onAccount" class="table-responsive-sm">
                                        <table aria-describedby="table" class="table table-sm table-bordered font-1">
                                            <thead>
                                                <tr class="table-primary">
                                                    <th scope="col" class="require" style="width:400px;">Customer</th>
                                                    <th scope="col">Description</th>
                                                    <th scope="col" class="require">Amount</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr v-for="(acrow, acindex) in accrows" :key="acindex">
                                                    <td>
                                                        <v-select v-model="acrow.acc_customer_id" name="acc_customer_id" id="acc_customer_id" label="text" :filterable="false" :options="customerArr" @search="onSearchCustomer" placeholder="Select Customer" class='custom-ci-auto-search'>
                                                            <template slot="no-options">
                                                                Search Customer...
                                                            </template>
                                                            <template slot="option" slot-scope="option">
                                                                <div class="d-center">
                                                                    {{ option.text }}
                                                                </div>
                                                            </template>
                                                            <template slot="selected-option" slot-scope="option">
                                                                <div class="selected d-center">
                                                                    {{ option.text }}
                                                                </div>
                                                            </template>
                                                        </v-select>
                                                        <div class="field-error">{{ acrow.customer_error_msg }}</div>
                                                    </td>
                                                    <td>
                                                        <input type="text" placeholder="Enter Description" v-model="acrow.description" name="description" id="description" class="form-control">
                                                    </td>
                                                    <td>
                                                        <input type="text" placeholder="Enter Amount" v-model="acrow.amount" name="amount" id="amount" class="form-control text-right" @keypress="isAmountCheck($event)">
                                                        <div class="field-error">{{acrow.amount_error_msg}}</div>
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                    <template v-if="specificInvoice">
                                        <div class="form-row">
                                            <div class="col-md-7">
                                                <div class="specific-calc">
                                                    <div class="font-1 font-bold">Specific Amount Calculation</div>
                                                    <div class="specific-calc-wrapper">
                                                    <input type="hidden" class="form-control" v-model="spc_invoice_id"/>
                                                    <div class="form-row">
                                                        <div class="col-sm-6 form-group">
                                                            <label class="control-label" for="name">Application Amount:</label>
                                                            <input type="text" class="form-control" v-model="application_amount" id="application_amount" placeholder="Enter Application Amount" name="application_amount" @keypress="isNumberKey($event)">
                                                        </div>
                                                        <div class="col-sm-6 form-group mt-4">
                                                            <label class="control-label" for="name">Open Amount: &nbsp;&nbsp;${{open_amount.toFixed(2)}}</label>
                                                        </div>
                                                    </div>
                                                    <div class="form-row">
                                                        <div class="col-sm-6 form-group">
                                                            <label class="control-label" for="discount_amount">Discount Amount:</label>
                                                            <input type="text" class="form-control" v-model="discount_amount" id="discount_amount" placeholder="Enter Discount Amount" name="discount_amount" @keypress="isNumberKey($event)">
                                                        </div>

                                                        <div class="col-sm-6 form-group mt-4">
                                                            <label class="control-label" for="name">Discount Available: &nbsp;&nbsp;{{discount_available}}</label>
                                                        </div>
                                                        </div>
                                                        <div class="form-row">
                                                        <div class="col-sm-6 form-group">
                                                            <label class="control-label" for="acc_amount">Accomodation Amount:</label>
                                                            <input type="text" class="form-control" v-model="acc_amount" id="acc_amount" placeholder="Enter Accomodation Amount" name="acc_amount" @keypress="isNumberKey($event)">
                                                        </div>
                                                        <div class="col-sm-6 form-group">
                                                            <label class="control-label" for="gl_account">Write Off Account:</label>
                                                            <v-select v-model="gl_account_id" name="gl_account_id" id="gl_account_id" label="text" :filterable="false" :options="accountsArr" @search="onSearchAccount" placeholder="Select GL Account" class="custom-ci-auto-search contract-data">
                                                                <template slot="no-options">
                                                                    Search GL Account...
                                                                </template>
                                                                <template slot="option" slot-scope="option">
                                                                    <div class="d-center">
                                                                        {{ option.text }}
                                                                    </div>
                                                                </template>
                                                                <template slot="selected-option" slot-scope="option">
                                                                    <div class="selected d-center">
                                                                        {{ option.text }}
                                                                    </div>
                                                                </template>
                                                            </v-select>
                                                            <div class="field-error">{{gl_account_error_msg}}</div>
                                                        </div>
                                                    </div>
                                                    <div class="form-row">
                                                        <div class="col-sm-6">
                                                            <label class="control-label" for="late_fee">Late Fee:</label>
                                                            <input type="text" class="form-control" v-model="late_fee" id="late_fee" placeholder="Enter Late Fee" name="late_fee" @keypress="isNumberKey($event)">
                                                        </div>
                                                        <div class="col-sm-6">
                                                            <label class="control-label" for="gl_account">Write Off Account:</label>
                                                            <v-select v-model="late_fee_gl_account_id" name="late_fee_gl_account_id" id="late_fee_gl_account_id" label="text" :filterable="false" :options="accountsArr" @search="onSearchAccount" placeholder="Select GL Account" class="custom-ci-auto-search contract-data">
                                                                <template slot="no-options">
                                                                    Search GL Account...
                                                                </template>
                                                                <template slot="option" slot-scope="option">
                                                                    <div class="d-center">
                                                                        {{ option.text }}
                                                                    </div>
                                                                </template>
                                                                <template slot="selected-option" slot-scope="option">
                                                                    <div class="selected d-center">
                                                                        {{ option.text }}
                                                                    </div>
                                                                </template>
                                                            </v-select>
                                                            <div class="field-error">{{late_fee_gl_account_error_msg}}</div>
                                                        </div>
                                                    </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </template>

                                    <div v-if="cashrows && cashrows.length > 0 && onCash" class="table-responsive-sm">
                                        <table aria-describedby="table" class="table table-sm table-bordered font-1">
                                            <thead>
                                                <tr class="table-primary">
                                                    <th scope="col" class="require" style="width:400px;">Account</th>
                                                    <th scope="col" >Description</th>
                                                    <th scope="col" >Tax</th>
                                                    <th scope="col" class="require">Amount</th>
                                                    <th scope="col" class="require">Action</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr v-for="(crow, cindex) in cashrows" :key="cindex">
                                                    <td>
                                                        <v-select v-model="crow.gl_account_id" name="gl_account_id" id="gl_account_id" label="text" :filterable="false" :options="accountsArr" @search="onSearchAccount" placeholder="Select GL Account" class="custom-ci-auto-search contract-data">
                                                            <template slot="no-options">
                                                                Search GL Account...
                                                            </template>
                                                            <template slot="option" slot-scope="option">
                                                                <div class="d-center">
                                                                    {{ option.text }}
                                                                </div>
                                                            </template>
                                                            <template slot="selected-option" slot-scope="option">
                                                                <div class="selected d-center">
                                                                    {{ option.text }}
                                                                </div>
                                                            </template>
                                                        </v-select>
                                                        <div class="field-error">{{crow.account_error_msg}}</div>
                                                    </td>
                                                    <td>
                                                        <input type="text" placeholder="Enter Description" v-model="crow.description" name="description" id="description" class="form-control">
                                                    </td>
                                                    <td>
                                                        <input type="text" placeholder="Enter Tax" v-model="crow.tax" name="tax" id="tax" class="form-control text-right" @keypress="isAmountCheck($event)">
                                                    </td>
                                                    <td>
                                                        <input type="text" placeholder="Enter Amount" v-model="crow.amount" name="amount" id="amount" class="form-control text-right">
                                                        <div class="field-error">{{crow.amount_error_msg}}</div>
                                                    </td>
                                                    <td class="text-center">
                                                        <template v-if="cashrows.length != 1">
                                                            <a href="javascript:void(0)" v-on:click.prevent="removeElement(cindex);"> <i class="fp-remove"></i>
                                                                </a>
                                                        </template>
                                                        <template v-else>
                                                            <span class="close-row"> _ </span>
                                                        </template>
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </table>
                                        <div class="btn-groups mb-3">
                                            <button type="submit" v-on:click.prevent="addRow()" class="btn btn-primary">
                                                <i class="fp-add"></i> Add Line Item
                                            </button>
                                        </div>
                                    </div>
                                    <div v-if="creditrows && creditrows.length > 0 && onSecurityDeposit" class="table-responsive-sm">
                                        <table aria-describedby="table" class="table table-sm table-bordered font-1">
                                            <thead>
                                                <tr class="table-primary">
                                                    <th scope="col">GL Account</th>
                                                    <th scope="col" class="require" style="width:400px;">Customer</th>
                                                    <th v-if="isUnit" scope="col" style="width:400px;">Asset</th>
                                                    <th v-if="!isUnit" scope="col" style="width:400px;">Description</th>
                                                    <th scope="col" class="require">Amount</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr v-for="(drow, dindex) in creditrows" :key="dindex">
                                                    <td>
                                                        <label>{{drow.gl_account_id.text}}</label>
                                                    </td>
                                                    <td>
                                                        <v-select v-model="drow.customer_id" name="credit_customer_id" id="credit_customer_id" label="text" :filterable="false" :options="customerArr" @search="onSearchCustomer" placeholder="Select Customer" class='custom-ci-auto-search'>
                                                            <template slot="no-options">
                                                                Search Customer...
                                                            </template>
                                                            <template slot="option" slot-scope="option">
                                                                <div class="d-center">
                                                                    {{ option.text }}
                                                                </div>
                                                            </template>
                                                            <template slot="selected-option" slot-scope="option">
                                                                <div class="selected d-center">
                                                                    {{ option.text }}
                                                                </div>
                                                            </template>
                                                        </v-select>
                                                        <div class="field-error">{{ drow.customer_error_msg }}</div>
                                                    </td>
                                                    <td v-if="isUnit">
                                                        <v-select v-model="drow.vehicle_id" name="vehicle_id" id="vehicle_id" label="text" :filterable="false" :options="vehicleArr" @search="onSearchVehicle" placeholder="Select Asset" class='custom-ci-auto-search'>
                                                            <template slot="no-options">
                                                                Search Asset...
                                                            </template>
                                                            <template slot="option" slot-scope="option">
                                                                <div class="d-center">
                                                                    {{ option.text }}
                                                                </div>
                                                            </template>
                                                            <template slot="selected-option" slot-scope="option">
                                                                <div class="selected d-center">
                                                                    {{ option.text }}
                                                                </div>
                                                            </template>
                                                        </v-select>
                                                        <!-- <div class="field-error">{{ drow.customer_error_msg }}</div> -->
                                                    </td>
                                                     <td v-if="!isUnit">
                                                        <input type="text" placeholder="Enter Description" v-model="drow.description" name="description" id="description" class="form-control">
                                                    </td>
                                                    <td>
                                                        <input type="text" placeholder="Enter Amount" v-model="drow.amount" name="amount" id="amount" class="form-control text-right" @keypress="isAmountCheck($event)">
                                                        <div class="field-error">{{drow.amount_error_msg}}</div>
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                </template>
                                <div class="field-error">{{common_error_msg}}</div>
                                <div class="form-group">
                                    <div class="alert alert-warning hide offset-sm-2 col-sm-6" id="alertError">
                                        <button type="button" class="close" data-dismiss="alert" aria-label="Close"><span aria-hidden="true">&times;</span></button>
                                        <strong id="errorMsg" class="field-error"></strong>
                                    </div>
                                </div>
                                <div class="btn-groups" v-if="specificInvoice || onAccount || onCash || onSecurityDeposit">
                                    <button type="submit" id="createReceiptBtn" v-if="$route.params.id > 0" class="btn btn-primary" v-on:click.prevent="mapSpecificInvoiceReceipt" >
                                    <i class="fp-reload"> </i>  Update
                                    </button>
                                    <button type="submit" id="createReceiptBtn" v-else class="btn btn-primary" v-on:click.prevent="mapSpecificInvoiceReceipt">
                                    <i class="fp-save"> </i>  Save
                                    </button>
                                    <button type="submit" id="cancelReceiptBtn" class="btn btn-tertiary" v-on:click.prevent="BackReceiptList">
                                    <i class="fp-close"> </i>  Cancel
                                    </button>
                                </div>
                            </form>
                        </section>
                    </div>
                </div>
            </template>
            <template v-else-if="cantAccessPage === false">
                <div class="container-fluid">
                    <div class="bg-white text-center">
                        <h1>
                            Oops!</h1>
                        <h2>
                            403 </h2>
                        <div class="error-details">
                            Sorry!, You don't have permission to access this page.
                        </div>
                    </div>
                </div>
            </template>
            <template v-else>
                <loading-content></loading-content>
            </template>
            <app-footer></app-footer>
        </div>
    </div>
</template>
<script>
import Vue from "vue";

import {commonMixins} from '../mixins/commonMixins';

import moment from 'moment'


export default {
  name: "ReceiptInvoiceMapper",
  
  metaInfo() {
      return {title: "Map Receipt | " +process.env.COPYRIGHT_NAME}
  },
  mixins:[commonMixins],
  data: () => ({
    isUnit: true,
    permissions: [],
    cantAccessPage: "",
    loading:false,
    payment_number:'',
    payment_date:'',
    bank_code:'',
    bankArr:[],
    bank_currency_code:'USD',
    payment_currency_code:'USD',
    rows:[],
    bank_reference:'',
    bank_error_msg:'',
    deposit_date_error_msg:'',
    receipt_date_error_msg:'',
    receipt_amount_error_msg:'',
    optionsDate: {
        format: 'MM/DD/YYYY',
        useCurrent: true,
    },
    difference:0.00,
    amount_applied:0.00,
    payment_amount:0.00,
    dist_company:'001',
    isRelease:false,
    receiptPaymentArr:[],
    receiptPayment:'',
    invoiceArr:[],
    invoice_id:'',
    invoice_error_msg:'',
    payment_type:'',
    customer_id:0,
    customerArr:[],
    customer_error_msg:'',
    specificInvoice:false,
    gl_account_error_msg:'',
    gl_account_id:'',
    accountsArr:[],
    acc_amount:0.00,
    discount_amount:0.00,
    open_amount:0.00,
    application_amount:0.00,
    discount_available:0.00,
    idArr:[],
    spc_invoice_id:0,
    current_open_amount:0,
    common_error_msg:"",
    accrows:[],
    onAccount:false,
    cashrows:[],
    onCash:false,
    glDisabled:false,
    custDisabled:false,
    adjustButton:true,
    late_fee_gl_account_id:'',
    late_fee:0.00,
    adjustFlow:false,
    late_fee_gl_account_error_msg:'',
    creditrows:[],
    vehicleArr:[],
    onSecurityDeposit:false
  }),
  watch:{

        //check permission change
        permissions: function (permissions) {

            var self = this;
            if (permissions.length > 0) {
                for (var i = 0; i < permissions.length; i++) {
                    if (permissions[i].name == 'add_payment_receipt') {
                        self.cantAccessPage = true;
                    }
                }
            }
        },

        receiptPayment:function(){
            var self = this;

            setTimeout(function(){

                self.loadReceiptItem();

            },500);
        },
        // rows: {
        //     handler: function (val, oldVal) {
        //         console.log(val)
        //         var self = this;
        //         var amount = 0;
        //         var totalAmount = 0
        //         for (var j = 0; j < val.length; j++) {

        //             totalAmount += parseFloat(val[j].amount);

        //         }
        //         self.amount_entered = parseFloat(totalAmount);

        //         self.difference = parseFloat(self.receipt_amount) - parseFloat(self.amount_entered);
        //     },
        //     deep: true
        // }
        customer_id:function(){
            var self = this;

            self.onSearchInvoice('');
        }
   },
  created: function() {

  },
  mounted: function() {
        var self = this;
        self.getPermissions();

        setTimeout(function () {
            var path = window.location.pathname;
            var segments = path.split("/");

            if (segments[3]) {
                self.getReceiptPayment(segments[3],'load');

                setTimeout(function(){

                    self.getMappedItems();

                },500);
            }

        }, 100);

        // self.fetchBanks();
  },
  methods: {
      isUnitSelect(event) {
          var self = this;
          self.isUnit = event.target.checked;
      },
      onSearchReceiptPayment(search, loading) {
        var self = this;
        // alert(search.length);
        if (search.length > 0) {
            // loading(true);
            self.getReceiptPayment(search,'search');
        }

    },
    onSearchAccount(search, loading) {
            var self = this;
            if (search.length > 2) {

                loading(true);
                self.searchField(loading, search, 'accounts', '');
            }
        },
    onSearchCustomer(search, loading) {
        var self = this;

        if (search.length > 2) {

            loading(true);
            self.searchField(loading, search, 'customer', '');
        }
    },
    onSearchVehicle(search, loading) {
        var self = this;

        if (search.length > 3) {

            loading(true);
            self.searchField(loading, search, 'vehicle', '');
        }
    },
    spInvoice:function(id,currentOpenInvAmt){
        $('.purchase-order-create-main').hide();
        var self = this;

        self.spc_invoice_id = id;
        // self.application_amount = self.difference;
        if (self.adjustFlow === true || self.difference <= 0){

            self.open_amount = currentOpenInvAmt;

        }else{

            self.open_amount = self.difference;

        }
        self.current_open_amount = currentOpenInvAmt;
        self.specificInvoice = true;
    },

    onSearchInvoice(search) {
        var self = this;
        var customerId = 0;
        if (self.customer_id == 0 || !self.customer_id.value){
            if (search.length < 4) {
                return;
            }
        }else{
            customerId = self.customer_id.value;
        }
            // self.searchField(loading, search, 'invoice', '');
        $.ajax({
            url: process.env.ROOT_API + "/invoices/customer/search",
            type: "POST",
            headers: this.ajxHeaders,
            data: {customer_id:customerId,flag:'invoice',search:search},
            crossDomain: true,
            dataType: "json",
            success: function (data) {
                self.invoiceArr = [];
                if (data.status == "success") {
                    self.invoiceArr = data.content;
                }else{
                    self.invoiceArr = [];
                }

            },
            error: function (jqXHR, exception) {
                loading(false);
                self.generateStatusCodeMessage(jqXHR,true,'customer-invoice-search');
            }
        });
    },
    grossInvoice: function(invoiceId,currentOpenInvAmt){
        var self = this;
        if (currentOpenInvAmt > self.payment_amount) {
            self.$swal('','Open Amount cannot be greater than PMT Amount.','info');
            return;
        }else{
            $.ajax({
                url: process.env.ROOT_API + "/map-invoice-receipt",
                type: "POST",
                headers: this.ajxHeaders,
                data:{
                    invoice_id:invoiceId,
                    receipt_item_id:self.receiptPayment.value
                },
                dataType: "json",
                success: function (data) {
                    self.loading = false;
                    console.log(data);
                    if (data.status == "success") {
                        self.amount_applied += data.content.application_amount;

                        self.calculateAmount();
                        self.getInvoices();
                    }
                },
                error: function (jqXHR, exception) {
                    self.loading = false;
                    self.generateStatusCodeMessage(jqXHR,false,'fetch-receipt-number')
                }
            });
        }

    },
    mapSpecificInvoiceReceipt:function(){
        var self = this;
        var path = window.location.pathname;
        var segments = path.split("/");
        var error = false;
        self.common_error_msg = "";

        if ((Number(self.application_amount) > self.current_open_amount) || (Number(self.application_amount) > self.open_amount)) {
            self.common_error_msg = "Application Amount cannot be greater than Open Amount.";
            error = true;
        }

        if (!error) {

            var fields = $("#ReceiptInvoiceMapperForm").serializeArray();

            fields.push({
                name: "receipt_item_id",
                value: self.receiptPayment.value
            });

                fields.push({
                        name: "invoice_id",
                        value: self.spc_invoice_id
                    });

                fields.push({
                        name: "application_amount",
                        value: self.application_amount
                    });

                fields.push({
                        name: "open_amount",
                        value: self.open_amount
                    });

                fields.push({
                        name: "discount_amount",
                        value: self.discount_amount
                    });

                fields.push({
                        name: "gl_account_id",
                        value: self.gl_account_id.value
                    });

                fields.push({
                        name: "accomodation_amount",
                        value: self.acc_amount
                    });

                fields.push({
                        name: "late_fee_gl_account_id",
                        value: self.late_fee_gl_account_id.value
                    });

                fields.push({
                        name: "late_fee",
                        value: self.late_fee
                    });

            var noNeedSp = false;

            if (self.creditrows && self.creditrows.length && self.onSecurityDeposit){
                self.onSecurityDepositStore();
                noNeedSp = true;
            }
            if (self.accrows && self.accrows.length && self.onAccount){
                self.onAccountMap();
                noNeedSp = true;
                return;
            }

            if (self.cashrows && self.cashrows.length  && self.onCash){
                self.onCashMap();
                noNeedSp = true;
                return;
            }

            if (noNeedSp){
                return;
            }
            $.ajax({
                url: process.env.ROOT_API + "/map-sp-invoice-receipt",
                type: "POST",
                headers: this.ajxHeaders,
                data:fields,
                dataType: "json",
                success: function (data) {
                    self.loading = false;
                    console.log(data);
                    if (data.status == "success") {
                        // self.amount_applied += data.content.application_amount;
                        if (self.specificInvoice){

                            self.specificInvoice = false;
                            self.application_amount = 0.00;
                            self.open_amount = 0.00;
                            self.discount_available = 0.00;
                            self.acc_amount = 0.00;
                            self.discount_amount = 0.00;
                            self.gl_account_id = '';
                            self.calculateAmount();
                            self.getInvoices();
                            $('.purchase-order-create-main').show();
                        }else{
                            self.onAccount = false;
                            self.accrows = [];
                            self.getMappedItems('account');
                        }
                    }
                },
                error: function (jqXHR, exception) {
                    self.loading = false;
                    // self.generateStatusCodeMessage(jqXHR,false,'fetch-receipt-number')
                }
            });

        }

    },

    onCashMap: function(){
        var self = this;

        var fields = $("#ReceiptInvoiceMapperForm").serializeArray();

        var amount = 0;
        var error = false;

        for (var i = 0; i < self.cashrows.length; i++) {
                    // console.log(self.rows[i]);
            self.cashrows[i].account_error_msg = "";
            self.cashrows[i].amount_error_msg = "";


            if (self.cashrows[i].gl_account_id == null || !self.cashrows[i].gl_account_id.value) {
                self.cashrows[i].account_error_msg = "GL Account is Required.";
                 error = true;
            }
            if (self.cashrows[i].amount == null || !self.cashrows[i].amount) {
                self.cashrows[i].amount_error_msg = "Amount is Required.";
                 error = true;
            }

            if (self.cashrows[i].mapper_id && self.cashrows[i].mapper_id > 0){

            }else{

                amount += parseFloat(self.cashrows[i].amount);
                amount += parseFloat(self.cashrows[i].tax);

            }

        }


        if (amount > self.difference){
            self.$swal('','Amount should not be greater than Remaining PMT Amount' ,'info');
            error = true;
        }

        fields.push({
            name: "receipt_item_id",
            value: self.receiptPayment.value
        });

        fields.push({
                name: "on_cash_item",
                value: JSON.stringify(self.cashrows)
            });

        if ( !error){

            $.ajax({
                url: process.env.ROOT_API + "/map-oncash-invoice-receipt",
                type: "POST",
                headers: this.ajxHeaders,
                data:fields,
                dataType: "json",
                success: function (data) {
                    self.loading = false;
                    console.log(data);
                    if (data.code == 201){
                        self.$swal('',data.message,'info');
                        return;
                    }
                    if (data.status == "success") {

                        self.onCash = false;
                        self.cashrows = [];
                        // if(data.content.application_amount){
                        //     self.amount_applied += data.content.application_amount;

                        //     self.calculateAmount();
                        // }
                        if (self.difference > 0){
                            if (self.$route.params.id == undefined){
                                self.$router.push('/receipt-invoice/map/'+self.receiptPayment.value);
                            }
                            self.loadReceiptItem();
                        }else{
                            self.$router.push('/payment-receipt/list');
                        }
                        // self.getMappedItems('cash');
                    }
                },
                error: function (jqXHR, exception) {
                    self.loading = false;
                    self.generateStatusCodeMessage(jqXHR,false,'fetch-receipt-number')
                }
            });
        }
    },
    onAccountMap: function(){
        var self = this;

        var amount = 0;
        var error = false;
        for (var i = 0; i < self.accrows.length; i++) {
                    // console.log(self.rows[i]);
            self.accrows[i].customer_error_msg = "";
            self.accrows[i].amount_error_msg = "";


            if (self.accrows[i].acc_customer_id == null || !self.accrows[i].acc_customer_id.value) {
                self.accrows[i].customer_error_msg = "Customer is Required.";
                error = true;
            }
            if (self.accrows[i].amount == null || !self.accrows[i].amount) {
                self.accrows[i].amount_error_msg = "Amount is Required.";
                error = true;
            }
            if (self.accrows[i].mapper_id && self.accrows[i].mapper_id > 0){

            }else{

                amount += parseFloat(self.accrows[i].amount);

            }
        }

        // TODO:MYR
        if (self.accrows && self.accrows.length && parseFloat(amount) > self.difference) {
            self.$swal('','Amount should not be greater than Remaining PMT Amount','info');
            error = true;
        }

        if (error === true){
            return;
        }

        var fields = $("#ReceiptInvoiceMapperForm").serializeArray();

        fields.push({
            name: "receipt_item_id",
            value: self.receiptPayment.value
        });

        fields.push({
                name: "on_account_item",
                value: JSON.stringify(self.accrows)
            });


        $.ajax({
            url: process.env.ROOT_API + "/map-onaccount-invoice-receipt",
            type: "POST",
            headers: this.ajxHeaders,
            data:fields,
            dataType: "json",
            success: function (data) {
                self.loading = false;
                console.log(data);
                if (data.code == 201){
                    self.$swal('',data.message,'info');
                    return;
                }
                if (data.status == "success") {

                    self.onAccount = false;
                    self.accrows = [];
                    if(data.content.application_amount){
                        self.amount_applied += data.content.application_amount;

                        self.calculateAmount();
                    }
                    if (self.difference > 0){
                        if (self.$route.params.id == undefined){
                            self.$router.push('/receipt-invoice/map/'+self.receiptPayment.value);
                        }
                        self.loadReceiptItem();
                    }else{
                        self.$router.push('/payment-receipt/list');
                    }
                    // self.getMappedItems('cash');
                }
            },
            error: function (jqXHR, exception) {
                self.loading = false;
                self.generateStatusCodeMessage(jqXHR,false,'fetch-receipt-number')
            }
        });

    },
    onSecurityDepositStore: function(){
        var self = this;

        var fields = $("#ReceiptInvoiceMapperForm").serializeArray();

        var amount = 0;
        var error = false;

        for (var i = 0; i < self.creditrows.length; i++) {
                    // console.log(self.rows[i]);
            self.creditrows[i].customer_error_msg = "";
            self.creditrows[i].amount_error_msg = "";


            if (self.creditrows[i].customer_id == null || !self.creditrows[i].customer_id.value) {
                self.creditrows[i].account_error_msg = "Customer is Required.";
                 error = true;
            }
            if (self.creditrows[i].amount == null || !self.creditrows[i].amount) {
                self.creditrows[i].amount_error_msg = "Amount is Required.";
                 error = true;
            }

            if (self.creditrows[i].mapper_id && self.creditrows[i].mapper_id > 0){

            }else{

                amount += parseFloat(self.creditrows[i].amount);

            }

        }


        if (amount > self.difference){
            self.$swal('','Amount should not be greater than Remaining PMT Amount' ,'info');
            error = true;
        }

        fields.push({
            name: "receipt_item_id",
            value: self.receiptPayment.value
        });

        fields.push({
                name: "deposit_item",
                value: JSON.stringify(self.creditrows)
            });

        if ( !error){

            $.ajax({
                url: process.env.ROOT_API + "/security-deposit-invoice-receipt",
                type: "POST",
                headers: this.ajxHeaders,
                data:fields,
                dataType: "json",
                success: function (data) {
                    self.loading = false;
                    console.log(data);
                    if (data.code == 201){
                        self.$swal('',data.message,'info');
                        return;
                    }
                    if (data.status == "success") {

                        self.onSecurityDeposit = false;
                        self.creditrows = [];
                        // if(data.content.application_amount){
                        //     self.amount_applied += data.content.application_amount;

                        //     self.calculateAmount();
                        // }
                        if (self.difference > 0){
                            if (self.$route.params.id == undefined){
                                self.$router.push('/receipt-invoice/map/'+self.receiptPayment.value);
                            }
                            self.loadReceiptItem();
                        }else{
                            self.$router.push('/payment-receipt/list');
                        }
                        // self.getMappedItems('cash');
                    }
                },
                error: function (jqXHR, exception) {
                    self.loading = false;
                    self.generateStatusCodeMessage(jqXHR,false,'fetch-receipt-number')
                }
            });
        }
    },
    getMappedItems: function(flag){
        var self = this;

         $.ajax({
            url: process.env.ROOT_API + "/get-mapped-items",
            type: "POST",
            headers: this.ajxHeaders,
            data:{
                item_id:self.receiptPayment.value
            },
            dataType: "json",
            success: function (data) {
                self.loading = false;
                console.log(data);
                if (data.status == "success") {
                    var path = window.location.pathname;
                    var segments = path.split("/");

                    // if (segments[3]) {
                    //     self.accrows.push({
                    //         mapper_id: 0,
                    //         acc_customer_id: data.content.application_amount,
                    //         customer_error_msg: "",
                    //         description: data.content.description,
                    //         amount: data.content.application_amount,
                    //         amount_error_msg:'',
                    //     });
                    // }


                    if(data.content.application_amount){
                        self.amount_applied += data.content.application_amount;

                        self.calculateAmount();
                    }
                }
            },
            error: function (jqXHR, exception) {
                self.loading = false;
                self.generateStatusCodeMessage(jqXHR,false,'fetch-receipt-number')
            }
        });

    },
    BackReceiptList() {
      var self = this;
      if (self.$route.params.id != undefined && self.$route.params.id > 0){
        self.$router.push("/receipt-item/list");
      }else{
        self.$router.push("/payment-receipt/list");
      }

    },
    cancelReceiptPayment:function(){
        var self = this;

        $.ajax({
            url: process.env.ROOT_API + "/cancel-receipt-payment",
            type: "POST",
            headers: this.ajxHeaders,
            data:{
                id:self.idArr,
                receipt_item_id:self.receiptPayment.value
            },
            dataType: "json",
            success: function (data) {
                self.loading = false;
                console.log(data);
                if (data.status == "success") {

                    self.idArr = [];
                    self.getInvoices();
                    self.loadReceiptItem();
                    // if (data.bank && self.$route.params.id == undefined){
                    //     self.bank_code = data.bank;
                    // }
                }
            },
            error: function (jqXHR, exception) {
                self.loading = false;
                self.generateStatusCodeMessage(jqXHR,false,'fetch-receipt-number')
            }
        });

    },

    clickRows(evt,id){
            var self = this;
            // alert(id);
            if (id == 0){
                self.$swal('','You can only cancel Applied invoice','info');
                evt.target.checked = false;
                return;
            }
            console.log(evt.target.checked);
            if(evt.target.checked == true){
                self.idArr.push({id:id});
            }else{
                var i = self.idArr.indexOf(id);
                const filteredItems = self.idArr.filter(function(item) {
                    return item.id !== id
                })
                self.idArr = filteredItems;
            }
            console.log(self.idArr);
        },
    getReceiptPayment: function(search,flag){
        var self = this;
        self.loading = true;
        $.ajax({
            url: process.env.ROOT_API + "/receipt_payment",
            type: "GET",
            headers: this.ajxHeaders,
            data:{
                search:search,
                flag:flag
            },
            dataType: "json",
            success: function (data) {
                self.loading = false;
                console.log(data);
                if (data.status == "success") {

                    if (flag == 'load'){
                        self.receiptPayment = data.content[0];
                    }else{

                        self.receiptPaymentArr = data.content;

                    }
                    // if (data.bank && self.$route.params.id == undefined){
                    //     self.bank_code = data.bank;
                    // }
                } else{

                    self.receiptPaymentArr = [];
                }
            },
            error: function (jqXHR, exception) {
                self.loading = false;
                self.generateStatusCodeMessage(jqXHR,false,'fetch-receipt-number')
            }
        });
    },

    loadReceiptItem() {
        console.log("load receipt")
        var path = window.location.pathname;
        var segments = path.split("/");
        var self = this;
        self.loading = true;
        $.ajax({
            url: process.env.ROOT_API + "/one-receipt-item/" + self.receiptPayment.value,
            type: "GET",
            headers: this.ajxHeaders,
            dataType: "json",
            success: function (data) {
                self.loading = false;
                if (data.status == "success") {
                    self.adjustButton = false;
                    self.payment_number = data.content.payment_number;
                    self.payment_date = data.content.payment_date;
                    self.bank_code = data.content.bank_code;
                    self.payment_currency_code = data.content.payment_currency_code;
                    self.payment_type =  data.content.type;
                    self.payment_amount = data.content.payment_amount;
                    self.difference = data.content.difference;
                    self.amount_applied = data.content.applied_amount;

                    if (segments[3] && data.content.invoices.invoice){
                        self.invoice_id = data.content.invoices.invoice;
                        self.getInvoices();

                    }

                    if ( data.content.invoices.cust){
                        self.customer_id = data.content.invoices.cust;

                    }

                    if ( data.content.invoices.customer){
                        var cust = data.content.invoices.customer;
                        self.accrows = [];
                         self.accrows.push({
                            mapper_id: cust.id,
                            acc_customer_id: {text:cust.customer,value:cust.customer_id},
                            customer_error_msg: "",
                            description: cust.description,
                            amount: cust.amount,
                            amount_error_msg:'',
                        });
                        self.custDisabled = true;
                        if (segments[3]){
                            self.onAccount = true;
                        }
                        var amount = 0;
                        // var accomodation_amount = 0;

                        // if (cust.amount){

                        //     amount = cust.amount;
                        // }

                        // self.amount_applied += amount;
                    }
                    if ( data.content.invoices.security){
                        var custsec = data.content.invoices.security;
                        if(!custsec.vehicle_id && custsec.vehicle_id == null) {
                          self.isUnit = false;
                        }
                        self.creditrows = [];
                         self.creditrows.push({
                            mapper_id: custsec.id,
                            gl_account_id: {text:custsec.gl,value:custsec.gl_account_id},
                            customer_id: {text:custsec.customer,value:custsec.customer_id},
                            customer_error_msg: "",
                            vehicle_id: (custsec.vehicle_id && custsec.vehicle_id != null) ? {text:custsec.vehicle,value:custsec.vehicle_id} : '',
                            amount: custsec.amount,
                            amount_error_msg:'',
                        });
                        // self.custDisabled = true;
                        // self.onAccount = true;
                        var amount = 0;
                        if (segments[3]){
                            self.onSecurityDeposit = true;
                        }
                    }

                    if ( data.content.invoices.gl){
                        var gl = data.content.invoices.gl;
                        if (gl.length > 0){
                            self.cashrows = [];
                            if (segments[3]){
                                self.onCash = true;
                            }
                            for (var i = 0; i < gl.length; i++){
                                self.cashrows.push({
                                    mapper_id: gl[i].id,
                                    gl_account_id: {text:gl[i].gl_account,value:gl[i].gl_account_id},
                                    account_error_msg: "",
                                    description: gl[i].description,
                                    amount: gl[i].amount,
                                    amount_error_msg:'',
                                    tax:gl[i].tax
                                });
                            }
                        }
                        self.glDisabled = true;
                    }

                    self.calculateAmount();
                }
            },
            error: function (jqXHR, exception) {
                self.loading = false;
                self.generateStatusCodeMessage(jqXHR,true,'one-vendor-invoice-item');
            }
        });
    },
    getInvoices: function(){
        var self = this;
        var path = window.location.pathname;
        var segments = path.split("/");
        var invArr = [];
        var customer_id = 0;
        if (!segments[3]){
            self.cashrows = [];
            self.accrows = [];
        }
        if(self.invoice_id != '' && self.invoice_id.length > 0){
            for(var i = 0; i < self.invoice_id.length; i++){
                invArr.push(self.invoice_id[i].value);
            }
        }else{
            if ( self.customer_id != null && self.customer_id.value ){
                customer_id = self.customer_id.value;
            }
        }

        self.loading = true;
        $.ajax({
            url: process.env.ROOT_API + "/get-receipt-invoices",
            type: "GET",
            headers: this.ajxHeaders,
            data:{
                id:invArr,
                customer_id:customer_id
            },
            dataType: "json",
            success: function (data) {
                self.loading = false;
                if (data.status == "success") {

                   self.rows = data.content;
                    var amount = 0;
                    var accomodation_amount = 0;

                    if (!segments[3]){

                        self.loadReceiptItem();

                    //     if(self.rows && self.rows.length > 0){
                    //         for(var i = 0; i < self.rows.length; i++){
                    //             if (self.rows[i].item_id && self.rows[i].item_id == self.receiptPayment.value){
                    //                 if (self.rows[i].application_amount){
                    //                 amount += self.rows[i].application_amount;
                    //                 }
                    //                 if (self.rows[i].accomodation_amount){
                    //                     accomodation_amount += self.rows[i].accomodation_amount;
                    //                 }
                    //             }
                    //         }

                    //         self.amount_applied += amount;
                    //         self.acc_amount = accomodation_amount;
                    //         self.payment_amount -= parseFloat(self.acc_amount);

                    //         self.difference = self.payment_amount - self.amount_applied;
                    //     }
                    }
                            $("input:checkbox").prop('checked',false);


                //    self.calculateAmount();
                }
            },
            error: function (jqXHR, exception) {
                self.loading = false;
                self.generateStatusCodeMessage(jqXHR,true,'vendor-invoice-items');
            }
        });
    },
    onAccountApp:function(){
        var self = this;
        $.ajax({
            url: process.env.ROOT_API + "/fetch-mapped/items",
            type: "GET",
            headers: this.ajxHeaders,
            dataType: "json",
            data:{
                flag:'on_cash',
                item:self.receiptPayment.value
            },
            success: function (data) {
                self.loading = false;
                console.log(data);
                if (data.status == "exist") {

                   self.$swal('','Already Mapped with GL','info');
                } else{
                //    self.cashrows = [];
                    self.rows = [];
                    // self.onCash = false;
                    // if (!self.accrows.length){
                        self.onAccount = true;
                        self.onCash = false;
                        self.onSecurityDeposit = false;
                    //     self.accrows.push({
                    //         mapper_id: 0,
                    //         acc_customer_id: '',
                    //         customer_error_msg: "",
                    //         description: "",
                    //         amount: 0.00,
                    //         amount_error_msg:'',
                    //     });
                    // }else{
                    //     self.accrows = [];
                    //     self.onAccount = false;
                    // }
                }
            },
            error: function (jqXHR, exception) {
                self.loading = false;
                self.generateStatusCodeMessage(jqXHR,false,'fetch-mapped-items')
            }
        });
    },

    cashFlow:function(){
        var self = this;

        $.ajax({
            url: process.env.ROOT_API + "/fetch-mapped/items",
            type: "GET",
            headers: this.ajxHeaders,
            dataType: "json",
            data:{
                flag:'account',
                item:self.receiptPayment.value
            },
            success: function (data) {
                self.loading = false;
                console.log(data);
                if (data.status == "exist") {

                   self.$swal('','Already Mapped with on account to customer','info');
                } else{
                    // self.accrows = [];
                    // self.onAccount = false;
                    self.rows = [];
                    // if (!self.cashrows.length){
                        self.onCash = true;
                        self.onAccount = false;
                        self.onSecurityDeposit = false;
                    //     self.cashrows.push({
                    //         mapper_id: 0,
                    //         gl_account_id: '',
                    //         account_error_msg: "",
                    //         description: "",
                    //         tax:0.00,
                    //         amount: 0.00,
                    //         amount_error_msg:'',
                    //     });
                    // }else{
                    //     self.cashrows = [];
                    //     self.onCash = false;
                    // }
                }
            },
            error: function (jqXHR, exception) {
                self.loading = false;
                self.generateStatusCodeMessage(jqXHR,false,'fetch-mapped-items')
            }
        });
    },
    creditDeposit:function(){
        var self = this;
        self.onAccount = false;
        self.onCash = false;
        self.onSecurityDeposit = true;
        

    },

    calculateAmount: function(){
        var self = this;

        // var amount = 0;
        // if(self.cashrows && self.cashrows.length > 0){

        //     for(var i = 0; i < self.cashrows.length; i++){
        //         if (self.cashrows[i].amount){
        //             amount += parseFloat(self.cashrows[i].amount);
        //             alert('amount ='+amount);
        //         }
        //         if (self.cashrows[i].tax){
        //             amount += parseFloat(self.cashrows[i].tax);

        //             alert('tax='+amount);
        //         }
        //     }

        // }
        // self.amount_applied += amount;

        self.difference = self.payment_amount - self.amount_applied;
    },
    addRow: function () {

            var self = this;
            var index = self.cashrows.length - 1;

            self.cashrows[index].account_error_msg = "";
            self.cashrows[index].amount_error_msg = "";

            if (self.cashrows[index].gl_account_id != null && self.cashrows[index].gl_account_id != '' && self.cashrows[index].gl_account_id.value && self.cashrows[index].amount &&
                self.cashrows[index].amount != '' && self.cashrows[index].amount > 0 ) {

                self.cashrows.push({
                    mapper_id: 0,
                    gl_account_id: '',
                    account_error_msg: "",
                    description: "",
                    tax:0.00,
                    amount: 0.00,
                    amount_error_msg:'',
                });

            } else {
                if (self.cashrows[index].gl_account_id == null || !self.cashrows[index].gl_account_id.value) {
                    self.cashrows[index].account_error_msg = "GL Account is Required.";
                }
                if (self.cashrows[index].amount == null || !self.cashrows[index].amount) {
                    self.cashrows[index].amount_error_msg = "Amount is Required.";
                }
            }
        },
        removeElement: function (index) {
            var self = this;
            if (self.cashrows.length > 1) {
                if (self.cashrows[index].mapper_id == 0) {
                    self.cashrows.splice(index, 1);

                } else {
                    if (confirm('Are you sure that you want to delete this Item? ')) {
                        self.idArr = [];
                        self.idArr.push({id:self.cashrows[index].mapper_id});
                        self.cancelReceiptPayment();
                        self.cashrows.splice(index, 1);
                    }
                }
            }
        },
    isNumberKey: function(evt) {

        var self = this;

        evt = (evt) ? evt : window.event;
        var charCode = (evt.which) ? evt.which : evt.keyCode;
        if ((charCode > 31 && (charCode < 48 || charCode > 57)) && (charCode !== 46 || evt.target.value.indexOf('.') != -1)) {
            evt.preventDefault();
        } else {
            return true;
        }
    },
    adjustReceipt:function(){
        var self = this;
        self.loading = true;
        $.ajax({
            url: process.env.ROOT_API + "/adjustment-receipt/create",
            type: "POST",
            headers: this.ajxHeaders,
            dataType: "json",
            success: function (data) {
                self.loading = false;
                console.log(data);
                if (data.status == "success") {
                    self.adjustFlow = true;
                    self.receiptPayment = {text:data.content.item,value:data.content.item_id};
                    self.adjustButton = false;
                } else{

                }
            },
            error: function (jqXHR, exception) {
                self.loading = false;
                self.generateStatusCodeMessage(jqXHR,false,'fetch-receipt-number')
            }
        });
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/ReceiptInvoiceMapper.vue